import React from 'react';
import QRCode from 'qrcode.react';
import {generateFbMessengerUrl} from '../../../utils/urls';
import ClipboardCopyInput from '../../ClipboardCopyInput';

const FbMessengerInfo = ({surveyId}) => (
    <div className="text-center">
        <QRCode value={generateFbMessengerUrl(surveyId)} size={256} level="M" className="my-4" />
        <ClipboardCopyInput readOnly value={generateFbMessengerUrl(surveyId)} />
    </div>
);

export default FbMessengerInfo;
